module.exports = __webpack_public_path__ + "static/media/icon_setting.73db7be0.png";